export default __webpack_public_path__ + "static/media/start-en.7b735448.gif";